import { FC } from 'react';
import image404 from 'images/404.svg';
import { ErrorTemplate } from './ErrorTemplate';
import { withTransaction } from '@elastic/apm-rum-react';

const NotFoundPage: FC = () =>
    <ErrorTemplate
        code={404}
        title="Page not found."
        message="Sorry, we couldn't find this page."
        imageUrl={image404}
    />;

export default withTransaction('NotFound', 'component')(NotFoundPage);

